import { createContext } from "react";
import type { AllChatbotActions } from "./lib/reducer/actions/actions";
import { chatbotInitialState } from "./lib/reducer/chatbot.reducer";
import type { ChatbotState } from "./lib/reducer/types/chatbot.reducer.type";

export interface IChatbotContext {
  state: ChatbotState;
  dispatch: React.Dispatch<AllChatbotActions>;
}

export const ChatbotContext = createContext<IChatbotContext>({
  state: chatbotInitialState,
  dispatch: () => {},
});
